import { TemplateRef } from '@angular/core';
import { Validators } from '@angular/forms';
import { Const, Custom, Option, Tarea, TareaRol } from '@app/shared';
import { BaseControl, Dropdown, TextArea, Textbox } from '@app/shared/dynamic-form';
import { find, isEmpty, result } from 'lodash';

export interface ConfigFields extends Tarea {
  statusOptions: Option[];
  typesOptions: Option[];
  selectRolesTpl: TemplateRef<any>;
  asignationRoles: TareaRol[];
  responsibleRoles: TareaRol[];
}

export class FormService {
  constructor() { }

  getFields(obj: Partial<ConfigFields>,generic: boolean=false): BaseControl<any>[] {
    if(generic){
      const controls: BaseControl<any>[] = [
        new Textbox({
          key: 'nombre',
          type: 'text',
          label: 'Nombre:',
          placeholder: 'Nombre predeterminado de la tarea',
          value: !isEmpty(obj.nombre) ? obj.nombre : null,
          order: 1,
          validations: {
            validators: [Validators.required, Validators.maxLength(255)]
          },
          disabled: true
        }),
  
        new TextArea({
          key: 'descripcion',
          label: 'Descripción:',
          placeholder: 'Descripción predeterminada de la tarea',
          rows: '2',
          value: !isEmpty(obj.descripcion) ? obj.descripcion : null,
          order: 2,
          validations: {
            validators: [Validators.required, Validators.minLength(5)]
          },
          disabled: true
        }),
        new Custom({
          key: 'asignationRoles',
          label: 'Roles para las asignaciones:',
          order: 4,
          value: !isEmpty(obj.asignationRoles) ? obj.asignationRoles : [],
          template: obj.selectRolesTpl,
          placeholder: 'Roles que pueden asignar esta tarea.',
          validations: {
            validators: [Validators.required]
          },
        }),
  
        new Custom({
          key: 'responsibleRoles',
          label: 'Roles responsables:',
          order: 5,
          value: !isEmpty(obj.responsibleRoles) ? obj.responsibleRoles : [],
          template: obj.selectRolesTpl,
          placeholder: 'Roles que pueden ejecutar esta tarea.',
          validations: {
            validators: [Validators.required]
          },
        }),
  
        new Textbox({
          key: 'rechazable',
          type: 'checkbox',
          label: 'Rechazable',
          class: {
            container: ['form-check', 'form-check-inline']
          },
          value: obj.hasOwnProperty('rechazable') ? obj.rechazable : false,
          order: 7
        })
      ];
      return controls;
    }else{
      const controls: BaseControl<any>[] = [
        new Textbox({
          key: 'nombre',
          type: 'text',
          label: 'Nombre:',
          placeholder: 'Nombre predeterminado de la tarea',
          value: !isEmpty(obj.nombre) ? obj.nombre : null,
          order: 1,
          validations: {
            validators: [Validators.required, Validators.maxLength(255)]
          }
        }),
  
        new TextArea({
          key: 'descripcion',
          label: 'Descripción:',
          placeholder: 'Descripción predeterminada de la tarea',
          rows: '2',
          value: !isEmpty(obj.descripcion) ? obj.descripcion : null,
          order: 2,
          validations: {
            validators: [Validators.required, Validators.minLength(5)]
          }
        }),
  
        new Dropdown({
          key: 'tarea_tipo',
          label: 'Tipo:',
          placeholder: 'Tipo predeterminado de la tarea',
          options: obj.typesOptions,
          value: !isEmpty(obj.tarea_tipo)
            ? obj.tarea_tipo.id
            : result(
              find(obj.typesOptions, {
                value: Const.TYPES_TASK.none as any
              }), 'key'
            ),
          order: 3,
          validations: {
            validators: [Validators.required]
          }
        }),
  
        new Custom({
          key: 'asignationRoles',
          label: 'Roles para las asignaciones:',
          order: 4,
          value: !isEmpty(obj.asignationRoles) ? obj.asignationRoles : [],
          template: obj.selectRolesTpl,
          placeholder: 'Roles que pueden asignar esta tarea.',
          validations: {
            validators: [Validators.required]
          },
          condictions: [
            {
              campoDepende: 'tarea_tipo',
              siEs: 'Igual',
              valor: 3,
              accion: 'Ocultar',
            }
          ]
        }),
  
        new Custom({
          key: 'responsibleRoles',
          label: 'Roles responsables:',
          order: 5,
          value: !isEmpty(obj.responsibleRoles) ? obj.responsibleRoles : [],
          template: obj.selectRolesTpl,
          placeholder: 'Roles que pueden ejecutar esta tarea.',
          validations: {
            validators: [Validators.required]
          },
          condictions: [
            {
              campoDepende: 'tarea_tipo',
              siEs: 'Igual',
              valor: 3,
              accion: 'Ocultar',
            }
          ]
        }),
  
        new Dropdown({
          key: 'tarea_estado',
          label: 'Estado:',
          placeholder: 'Estado predeterminado de la tarea',
          options: obj.statusOptions,
          value: !isEmpty(obj.tarea_estado)
            ? obj.tarea_estado.id
            : result(
              obj.statusOptions.find(el => {
                return (<string>el.value).toLocaleLowerCase() === Const.STATUS_TASK.pending;
              }), 'key'
            ),
          order: 5,
          validations: {
            validators: [Validators.required]
          }
        }),
  
        new Textbox({
          key: 'activo',
          type: 'checkbox',
          label: 'Activa',
          class: {
            container: ['form-check', 'form-check-inline']
          },
          value: obj.hasOwnProperty('activo') ? obj.activo : false,
          order: 6,
        }),
  
        new Textbox({
          key: 'rechazable',
          type: 'checkbox',
          label: 'Rechazable',
          class: {
            container: ['form-check', 'form-check-inline']
          },
          value: obj.hasOwnProperty('rechazable') ? obj.rechazable : false,
          order: 7,
          condictions: [
            {
              campoDepende: 'tarea_tipo',
              siEs: 'Igual',
              valor: 3,
              accion: 'Ocultar',
            }
          ]
        }),
  
        new Textbox({
          key: 'reasignacion',
          type: 'checkbox',
          label: 'Reasignación',
          class: {
            container: ['form-check', 'form-check-inline']
          },
          value: obj.hasOwnProperty('reasignacion') ? obj.reasignacion : false,
          order: 8,
        }),

        new Textbox({
          key: 'reasignacion_validaciones_especiales',
          type: 'checkbox',
          label: 'reasignacion validaciones especiales',
          class: {
            container: ['form-check', 'form-check-inline']
          },
          value: obj.hasOwnProperty('reasignacion_validaciones_especiales') ? obj.reasignacion_validaciones_especiales : false,
          order: 9,
        }),
  
        new Textbox({
          key: 'modificacion',
          type: 'checkbox',
          label: 'Modificación',
          class: {
            container: ['form-check', 'form-check-inline']
          },
          value: obj.hasOwnProperty('modificacion') ? obj.modificacion : false,
          order: 10,
        }),
  
        new Textbox({
          key: 'historial',
          type: 'checkbox',
          label: 'Historial',
          class: {
            container: ['form-check', 'form-check-inline']
          },
          value: obj.hasOwnProperty('historial') ? obj.historial : false,
          order: 11,
        }),
  
        new Textbox({
          key: 'gestion_responsable',
          type: 'checkbox',
          label: 'Gestion de responsables',
          class: {
            container: ['form-check', 'form-check-inline']
          },
          value: obj.hasOwnProperty('gestion_responsable') ? obj.gestion_responsable : false,
          order: 12,
        })
      ];
      return controls;
    }
   
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/task/shared/form-service.ts